/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListTunneledMcpServerConnectionsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListTunneledMcpServerConnectionsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListTunneledMcpServerConnectionsSecurity = {
  option1?: ListTunneledMcpServerConnectionsSecurityOption1 | undefined;
  option2?: ListTunneledMcpServerConnectionsSecurityOption2 | undefined;
};

export type ListTunneledMcpServerConnectionsRequest = {
  /**
   * The ID of the tunneled MCP server
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListTunneledMcpServerConnectionsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListTunneledMcpServerConnectionsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListTunneledMcpServerConnectionsSecurityOption1$Outbound,
    ListTunneledMcpServerConnectionsSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listTunneledMcpServerConnectionsSecurityOption1ToJSON(
  listTunneledMcpServerConnectionsSecurityOption1:
    ListTunneledMcpServerConnectionsSecurityOption1,
): string {
  return JSON.stringify(
    ListTunneledMcpServerConnectionsSecurityOption1$outboundSchema.parse(
      listTunneledMcpServerConnectionsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListTunneledMcpServerConnectionsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListTunneledMcpServerConnectionsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListTunneledMcpServerConnectionsSecurityOption2$Outbound,
    ListTunneledMcpServerConnectionsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listTunneledMcpServerConnectionsSecurityOption2ToJSON(
  listTunneledMcpServerConnectionsSecurityOption2:
    ListTunneledMcpServerConnectionsSecurityOption2,
): string {
  return JSON.stringify(
    ListTunneledMcpServerConnectionsSecurityOption2$outboundSchema.parse(
      listTunneledMcpServerConnectionsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListTunneledMcpServerConnectionsSecurity$Outbound = {
  Option1?:
    | ListTunneledMcpServerConnectionsSecurityOption1$Outbound
    | undefined;
  Option2?:
    | ListTunneledMcpServerConnectionsSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const ListTunneledMcpServerConnectionsSecurity$outboundSchema:
  z.ZodMiniType<
    ListTunneledMcpServerConnectionsSecurity$Outbound,
    ListTunneledMcpServerConnectionsSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        ListTunneledMcpServerConnectionsSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        ListTunneledMcpServerConnectionsSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function listTunneledMcpServerConnectionsSecurityToJSON(
  listTunneledMcpServerConnectionsSecurity:
    ListTunneledMcpServerConnectionsSecurity,
): string {
  return JSON.stringify(
    ListTunneledMcpServerConnectionsSecurity$outboundSchema.parse(
      listTunneledMcpServerConnectionsSecurity,
    ),
  );
}

/** @internal */
export type ListTunneledMcpServerConnectionsRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListTunneledMcpServerConnectionsRequest$outboundSchema:
  z.ZodMiniType<
    ListTunneledMcpServerConnectionsRequest$Outbound,
    ListTunneledMcpServerConnectionsRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
      });
    }),
  );

export function listTunneledMcpServerConnectionsRequestToJSON(
  listTunneledMcpServerConnectionsRequest:
    ListTunneledMcpServerConnectionsRequest,
): string {
  return JSON.stringify(
    ListTunneledMcpServerConnectionsRequest$outboundSchema.parse(
      listTunneledMcpServerConnectionsRequest,
    ),
  );
}
